export const SPOTLIGHT = [
  {name:"MAKTX",desc:"NOME",value:"Alfaiataria"},
  {name:"MAKTX",desc:"NOME",value:"Armani"},
  {name:"MAKTX",desc:"NOME",value:"Bali"},
  {name:"MAKTX",desc:"NOME",value:"Bi"},
  {name:"MAKTX",desc:"NOME",value:"Biscuit"},
  {name:"MAKTX",desc:"NOME",value:"Cambraia"},
  {name:"MAKTX",desc:"NOME",value:"Camisaria"},
  {name:"MAKTX",desc:"NOME",value:"Cashmere"},
  {name:"MAKTX",desc:"NOME",value:"Cetim"},
  {name:"MAKTX",desc:"NOME",value:"Charmeuse"},
  {name:"MAKTX",desc:"NOME",value:"Chevron"},
  {name:"MAKTX",desc:"NOME",value:"Chiffon"},
  {name:"MAKTX",desc:"NOME",value:"Circle"},
  {name:"MAKTX",desc:"NOME",value:"City"},
  {name:"MAKTX",desc:"NOME",value:"Clark"},
  {name:"MAKTX",desc:"NOME",value:"Compact"},
  {name:"MAKTX",desc:"NOME",value:"Concept"},
  {name:"MAKTX",desc:"NOME",value:"Cotele"},
  {name:"MAKTX",desc:"NOME",value:"Cotton"},
  {name:"MAKTX",desc:"NOME",value:"Crepe"},
  {name:"MAKTX",desc:"NOME",value:"Crepon"},
  {name:"MAKTX",desc:"NOME",value:"Crochet"},
  {name:"MAKTX",desc:"NOME",value:"Dot"},
  {name:"MAKTX",desc:"NOME",value:"Elegance"},
  {name:"MAKTX",desc:"NOME",value:"Extra"},
  {name:"MAKTX",desc:"NOME",value:"Flow"},
  {name:"MAKTX",desc:"NOME",value:"Focus"},
  {name:"MAKTX",desc:"NOME",value:"Foil"},
  {name:"MAKTX",desc:"NOME",value:"Gaze"},
  {name:"MAKTX",desc:"NOME",value:"Glam"},
  {name:"MAKTX",desc:"NOME",value:"Gloss"},
  {name:"MAKTX",desc:"NOME",value:"Guipir"},
  {name:"MAKTX",desc:"NOME",value:"Helanca"},
  {name:"MAKTX",desc:"NOME",value:"Hi"},
  {name:"MAKTX",desc:"NOME",value:"Indicolor"},
  {name:"MAKTX",desc:"NOME",value:"Indigo"},
  {name:"MAKTX",desc:"NOME",value:"Jacquard"},
  {name:"MAKTX",desc:"NOME",value:"Jersey"},
  {name:"MAKTX",desc:"NOME",value:"Lalique"},
  {name:"MAKTX",desc:"NOME",value:"Leather"},
  {name:"MAKTX",desc:"NOME",value:"Light"},
  {name:"MAKTX",desc:"NOME",value:"Linen"},
  {name:"MAKTX",desc:"NOME",value:"Linho"},
  {name:"MAKTX",desc:"NOME",value:"Liquid"},
  {name:"MAKTX",desc:"NOME",value:"Malha"},
  {name:"MAKTX",desc:"NOME",value:"Melange"},
  {name:"MAKTX",desc:"NOME",value:"Matelasse"},
  {name:"MAKTX",desc:"NOME",value:"Maui"},
  {name:"MAKTX",desc:"NOME",value:"Moletinho"},
  {name:"MAKTX",desc:"NOME",value:"Moleton"},
  {name:"MAKTX",desc:"NOME",value:"Multi"},
  {name:"MAKTX",desc:"NOME",value:"Newprene"},
  {name:"MAKTX",desc:"NOME",value:"Opaque"},
  {name:"MAKTX",desc:"NOME",value:"Organza"},
  {name:"MAKTX",desc:"NOME",value:"Ossie"},
  {name:"MAKTX",desc:"NOME",value:"Ossy"},
  {name:"MAKTX",desc:"NOME",value:"Ounge"},
  {name:"MAKTX",desc:"NOME",value:"Oxford"},
  {name:"MAKTX",desc:"NOME",value:"Paetê"},
  {name:"MAKTX",desc:"NOME",value:"Pele"},
  {name:"MAKTX",desc:"NOME",value:"Pelúcia"},
  {name:"MAKTX",desc:"NOME",value:"Poly"},
  {name:"MAKTX",desc:"NOME",value:"Premium"},
  {name:"MAKTX",desc:"NOME",value:"Preppy"},
  {name:"MAKTX",desc:"NOME",value:"Printed"},
  {name:"MAKTX",desc:"NOME",value:"Rayon"},
  {name:"MAKTX",desc:"NOME",value:"Renda"},
  {name:"MAKTX",desc:"NOME",value:"Rustic"},
  {name:"MAKTX",desc:"NOME",value:"Sassy"},
  {name:"MAKTX",desc:"NOME",value:"Satin"},
  {name:"MAKTX",desc:"NOME",value:"Silky"},
  {name:"MAKTX",desc:"NOME",value:"Span"},
  {name:"MAKTX",desc:"NOME",value:"Stretch"},
  {name:"MAKTX",desc:"NOME",value:"Stripe"},
  {name:"MAKTX",desc:"NOME",value:"Suede"},
  {name:"MAKTX",desc:"NOME",value:"Surface"},
  {name:"MAKTX",desc:"NOME",value:"Sweet"},
  {name:"MAKTX",desc:"NOME",value:"Tafetá"},
  {name:"MAKTX",desc:"NOME",value:"Techno"},
  {name:"MAKTX",desc:"NOME",value:"Texture"},
  {name:"MAKTX",desc:"NOME",value:"Torsion"},
  {name:"MAKTX",desc:"NOME",value:"Transparência"},
  {name:"MAKTX",desc:"NOME",value:"Tricoline"},
  {name:"MAKTX",desc:"NOME",value:"Tricot"},
  {name:"MAKTX",desc:"NOME",value:"Tule"},
  {name:"MAKTX",desc:"NOME",value:"Tweed"},
  {name:"MAKTX",desc:"NOME",value:"Twill"},
  {name:"MAKTX",desc:"NOME",value:"Veludo"},
  {name:"MAKTX",desc:"NOME",value:"Visco"},
  {name:"MAKTX",desc:"NOME",value:"Viscose"},
  {name:"MAKTX",desc:"NOME",value:"Voil"},
  {name:"CMP",desc:"COMPOSIÇÃO",value:"Acrílica"},
  {name:"CMP",desc:"COMPOSIÇÃO",value:"Algodão"},
  {name:"CMP",desc:"COMPOSIÇÃO",value:"Elastano"},
  {name:"CMP",desc:"COMPOSIÇÃO",value:"Lã"},
  {name:"CMP",desc:"COMPOSIÇÃO",value:"Linho"},
  {name:"CMP",desc:"COMPOSIÇÃO",value:"Metálica"},
  {name:"CMP",desc:"COMPOSIÇÃO",value:"Poliamida"},
  {name:"CMP",desc:"COMPOSIÇÃO",value:"Poliéster"},
  {name:"CMP",desc:"COMPOSIÇÃO",value:"Seda"},
  {name:"CMP",desc:"COMPOSIÇÃO",value:"Viscose"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Acabamentos Diferenciados"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Animal Print"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Aspectos de Denim"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Aveludados"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Bordados"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Bordados em Tule"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Bordados em Malha"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Chevron"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Clássicas"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Creponados"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Crochets"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Devores"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Dublados"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Dupla Face"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Elásticas"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Estampados"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Estruturas Diferenciadas"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Falsos Lisos"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Feltrados"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Bordados em Renda"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Flames"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Forros"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Guipir"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Jacquards"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Lanosos"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Lisos"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Listrados"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Xadrezes"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Maquinetados"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Mesclas"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Metalizados"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Micro Padronagens"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Risca de Giz"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Texturas"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Toque Natural"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Tricots"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Veludos"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Xadrez"},
  {name:"SGRUPO",desc:"ASPECTO",value:"4,0 oz a 6,9 oz"},
  {name:"SGRUPO",desc:"ASPECTO",value:"7,0 oz a 8,9 oz"},
  {name:"SGRUPO",desc:"ASPECTO",value:"9,0 oz a 14,0 oz"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Semi-Transparência"},
  {name:"SGRUPO",desc:"ASPECTO",value:"Tweed"},
  {name:"GRUPO",desc:"GRUPO",value:"Acetinados"},
  {name:"GRUPO",desc:"GRUPO",value:"Alfaiataria"},
  {name:"GRUPO",desc:"GRUPO",value:"Aspectos de Linho"},
  {name:"GRUPO",desc:"GRUPO",value:"Aspectos Naturais Leves"},
  {name:"GRUPO",desc:"GRUPO",value:"Aspectos Naturais Médios"},
  {name:"GRUPO",desc:"GRUPO",value:"Aspectos Naturais Pesados"},
  {name:"GRUPO",desc:"GRUPO",value:"Paetês"},
  {name:"GRUPO",desc:"GRUPO",value:"Tafetás"},
  {name:"GRUPO",desc:"GRUPO",value:"Tecnológicos"},
  {name:"GRUPO",desc:"GRUPO",value:"Transparências"},
  {name:"GRUPO",desc:"GRUPO",value:"Jeanswear FIX"},
  {name:"GRUPO",desc:"GRUPO",value:"Jeanswear FLEX"},
  {name:"GRUPO",desc:"GRUPO",value:"Aspectos de Couro"},
  {name:"GRUPO",desc:"GRUPO",value:"Malhas Leves"},
  {name:"GRUPO",desc:"GRUPO",value:"Malhas Médias"},
  {name:"GRUPO",desc:"GRUPO",value:"Malhas Pesadas"},
  {name:"GRUPO",desc:"GRUPO",value:"Peles"},
  {name:"GRUPO",desc:"GRUPO",value:"Rendas"},
  {name:"GRUPO",desc:"GRUPO",value:"Tules"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Brancos"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Amarelos"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Corais Alaranjados"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Vermelhos"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Corais Rosados"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Azuis"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Verdes"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Beges"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Cinzas"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Preto"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Estampados"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Fios tintos"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Off-white"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Salmon"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Vinhos"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Lilás"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Cafés"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Laranjas"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Rosas"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Caquis"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Roxos"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Marrons"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Violetas"},
  {name:"GRUPO_CORES",desc:"GRUPO DE CORES",value:"Terrosos"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Floral"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Geométrico"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Bicho"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Étnico"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Bola"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Figurativo"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Gravataria"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Infantil"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Listrado"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Manchado"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Patchwork"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Surfwear"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Xadrez"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Barrado"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Cashmere"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Simulação de Tecido"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Folhagem"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Camuflado"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Grafismo"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Abstrato"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Oriental"},
  {name:"MOTIVO_PADRAO",desc:"MOTIVOS",value:"Bayadère"},
  {name:"MOTIVO_DETALHE",desc:"DETALHES",value:"Pequeno"},
  {name:"MOTIVO_DETALHE",desc:"DETALHES",value:"Grande"},
  {name:"MOTIVO_DETALHE",desc:"DETALHES",value:"Médio"},
  {name:"MOTIVO_DETALHE",desc:"DETALHES",value:"Bicolor"},
  {name:"MOTIVO_DETALHE",desc:"DETALHES",value:"Vertical"},
  {name:"MOTIVO_DETALHE",desc:"DETALHES",value:"Horizontal"},
  {name:"MOTIVO_DETALHE",desc:"DETALHES",value:"Gravataria"},
  {name:"MOTIVO_DETALHE",desc:"DETALHES",value:"Diagonal"},
  {name:"MOTIVO_DETALHE",desc:"DETALHES",value:"Outro"},
  {name:"MOTIVO_DETALHE",desc:"DETALHES",value:"Mini"},
  {name:"MOTIVO_DETALHE",desc:"DETALHES",value:"Tonado"},
  {name:"MOTIVO_DETALHE",desc:"DETALHES",value:"Tropical"},
  {name:"TECIMENTO",desc:"TECIMENTO",value:"Estampado Plano"},
  {name:"TECIMENTO",desc:"TECIMENTO",value:"Estampado Malha"}
];
